/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangeLog } from '../models/ChangeLog';
import type { ChangeLogRequest } from '../models/ChangeLogRequest';
import type { Customer } from '../models/Customer';
import type { CustomerRequest } from '../models/CustomerRequest';
import type { PatchedCustomerRequest } from '../models/PatchedCustomerRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomersService {
    /**
     * @returns Customer
     * @throws ApiError
     */
    public static customersCustomersCreate({
        requestBody,
    }: {
        requestBody: CustomerRequest,
    }): CancelablePromise<Customer> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customers/customers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ChangeLog
     * @throws ApiError
     */
    public static customersCustomersLogsList({
        customerId,
    }: {
        customerId: number,
    }): CancelablePromise<Array<ChangeLog>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customers/customers/{customer_id}/logs/',
            path: {
                'customer_id': customerId,
            },
        });
    }
    /**
     * @returns ChangeLog
     * @throws ApiError
     */
    public static customersCustomersLogsCreate({
        customerId,
        requestBody,
    }: {
        customerId: number,
        requestBody?: ChangeLogRequest,
    }): CancelablePromise<ChangeLog> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customers/customers/{customer_id}/logs/',
            path: {
                'customer_id': customerId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Customer
     * @throws ApiError
     */
    public static customersCustomersUpdate({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: CustomerRequest,
    }): CancelablePromise<Customer> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/customers/customers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Customer
     * @throws ApiError
     */
    public static customersCustomersPartialUpdate({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PatchedCustomerRequest,
    }): CancelablePromise<Customer> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/customers/customers/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static customersCustomersPriorityIntegrationCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customers/customers/priority-integration/',
        });
    }
}
